import { createAction } from "redux-actions";

export const init = createAction("MERCHANT_WEB_INIT");
export const launchApp = () => (dispatch) => dispatch(init());
